export interface Country {
    id: string,
    name: string,
    countryCode2: string,
    countryCode3: string,
    countryPrefix: string
}

export var countries: Country [] = [
    {
        id: '101',
        name: 'Aruba',
        countryCode2: 'AW',
        countryCode3: 'ABW',
        countryPrefix: '+297',
    },
    {
        id: '95',
        name: 'Afghanistan',
        countryCode2: 'AF',
        countryCode3: 'AFG',
        countryPrefix: '+93'
    },
    {
        id: '100',
        name: 'Angola',
        countryCode2: 'AO',
        countryCode3: 'AGO',
        countryPrefix: '+244'
    },
    {
        id: '97',
        name: 'Anguilla',
        countryCode2: 'AI',
        countryCode3: 'AIA',
        countryPrefix: '+1-264',
    },
    {
        id: '206',
        name: 'Åland',
        countryCode2: 'AX',
        countryCode3: 'ALA',
        countryPrefix: '+35818'
    },
    {
        id: '98',
        name: 'Albania',
        countryCode2: 'AL',
        countryCode3: 'ALB',
        countryPrefix: '+355',
    },
    {
        id: '94',
        name: 'Andorra',
        countryCode2: 'AD',
        countryCode3: 'AND',
        countryPrefix: '+376',
    },
    {
        id: '31',
        name: 'United Arab Emirates',
        countryCode2: 'AE',
        countryCode3: 'ARE',
        countryPrefix: '+971',
    },
    {
        id: '33',
        name: 'Argentina',
        countryCode2: 'AR',
        countryCode3: 'ARG',
        countryPrefix: '+54',
    },
    {
        id: '99',
        name: 'Armenia',
        countryCode2: 'AM',
        countryCode3: 'ARM',
        countryPrefix: '+374',
    },
    {
        id: '96',
        name: 'Antigua and Barbuda',
        countryCode2: 'AG',
        countryCode3: 'ATG',
        countryPrefix: '+1-268',
    },
    {
        id: '34',
        name: 'Australia', countryCode2: 'AU',
        countryCode3: 'AUS',
        countryPrefix: '+61',
    },
    {
        id: '10',
        name: 'Austria', countryCode2: 'AT',
        countryCode3: 'AUT',
        countryPrefix: '+43'
    },
    {
        id: '102',
        name: 'Azerbaijan', countryCode2: 'AZ',
        countryCode3: 'AZE',
        countryPrefix: '+994',
    },
    {
        id: '105',
        name: 'Burundi', countryCode2: 'BI',
        countryCode3: 'BDI',
        countryPrefix: '+257',
    },
    {
        id: '2',
        name: 'Belgium', countryCode2: 'BE',
        countryCode3: 'BEL',
        countryPrefix: '+32'
    },
    {
        id: '106',
        name: 'Benin', countryCode2: 'BJ',
        countryCode3: 'BEN',
        countryPrefix: '+229',
    },
    {
        id: '104',
        name: 'Burkina Faso', countryCode2: 'BF',
        countryCode3: 'BFA',
        countryPrefix: '+226',
    },
    {
        id: '103',
        name: 'Bangladesh', countryCode2: 'BD',
        countryCode3: 'BGD',
        countryPrefix: '+880',
    },
    {
        id: '37',
        name: 'Bulgaria', countryCode2: 'BG',
        countryCode3: 'BGR',
        countryPrefix: '+359'
    },
    {
        id: '38',
        name: 'Bahrain', countryCode2: 'BH',
        countryCode3: 'BHR',
        countryPrefix: '+973',
    },
    {
        id: '109',
        name: 'Bahamas', countryCode2: 'BS',
        countryCode3: 'BHS',
        countryPrefix: '+1-242',
    },
    {
        id: '88',
        name: 'Bosnia and Herzegovina', countryCode2: 'BA',
        countryCode3: 'BIH',
        countryPrefix: '+387',
    },
    {
        id: '112',
        name: 'Belarus', countryCode2: 'BY',
        countryCode3: 'BLR',
        countryPrefix: '+375',
    },
    {
        id: '113',
        name: 'Belize', countryCode2: 'BZ',
        countryCode3: 'BLZ',
        countryPrefix: '+501',
    },
    {
        id: '107',
        name: 'Bermuda', countryCode2: 'BM',
        countryCode3: 'BMU',
        countryPrefix: '+1-441',
    },
    {
        id: '39',
        name: 'Plurinational State of Bolivia',
        countryCode2: 'BO',
        countryCode3: 'BOL',
        countryPrefix: '+591',
    },
    {
        id: '20',
        name: 'Brazil',
        countryCode2: 'BR',
        countryCode3: 'BRA',
        countryPrefix: '+55',
    },
    {
        id: '36',
        name: 'Barbados',
        countryCode2: 'BB',
        countryCode3: 'BRB',
        countryPrefix: '+1-246',
    },
    {
        id: '108',
        name: 'Brunei Darussalam',
        countryCode2: 'BN',
        countryCode3: 'BRN',
        countryPrefix: '+673',
    },
    {
        id: '110',
        name: 'Bhutan', countryCode2: 'BT',
        countryCode3: 'BTN',
        countryPrefix: '+975',
    },
    {
        id: '111',
        name: 'Botswana', countryCode2: 'BW',
        countryCode3: 'BWA',
        countryPrefix: '+267',
    },
    {
        id: '115',
        name: 'Central African Republic',
        countryCode2: 'CF',
        countryCode3: 'CAF',
        countryPrefix: '+236',
    },
    {
        id: '7',
        name: 'Canada', countryCode2: 'CA',
        countryCode3: 'CAN',
        countryPrefix: '+1',
    },
    {
        id: '13',
        name: 'Switzerland', countryCode2: 'CH',
        countryCode3: 'CHE',
        countryPrefix: '+41',
    },
    {
        id: '21',
        name: 'Chile', countryCode2: 'CL',
        countryCode3: 'CHL',
        countryPrefix: '+56',
    },
    {
        id: '22',
        name: 'China',
        countryCode2: 'CN',
        countryCode3: 'CHN',
        countryPrefix: '+86',
    },
    {
        id: '116',
        name: 'Cote d\'Ivoire', countryCode2: 'CI',
        countryCode3: 'CIV',
        countryPrefix: '+225',
    },
    {
        id: '117',
        name: 'Cameroon', countryCode2: 'CM',
        countryCode3: 'CMR',
        countryPrefix: '+237',
    },
    {
        id: '114',
        name: 'The Democratic Republic of the Congo', countryCode2: 'CD',
        countryCode3: 'COD',
        countryPrefix: '+243',
    },
    {
        id: '40',
        name: 'Colombia', countryCode2: 'CO',
        countryCode3: 'COL',
        countryPrefix: '+57',
    },
    {
        id: '142',
        name: 'Comoros', countryCode2: 'KM',
        countryCode3: 'COM',
        countryPrefix: '+269',
    },
    {
        id: '43',
        name: 'Cape Verde', countryCode2: 'CV',
        countryCode3: 'CPV',
        countryPrefix: '+238',
    },
    {
        id: '41',
        name: 'Costa Rica', countryCode2: 'CR',
        countryCode3: 'CRI',
        countryPrefix: '+506',
    },
    {
        id: '42',
        name: 'Cuba', countryCode2: 'CU',
        countryCode3: 'CUB',
        countryPrefix: '+53',
    },
    {
        id: '44',
        name: 'Cyprus', countryCode2: 'CY',
        countryCode3: 'CYP',
        countryPrefix: '+357'
    },
    {
        id: '16',
        name: 'Czech Republic', countryCode2: 'CZ',
        countryCode3: 'CZE',
        countryPrefix: '+420'
    },
    {
        id: '1',
        name: 'Germany', countryCode2: 'DE',
        countryCode3: 'DEU',
        countryPrefix: '+49'
    },
    {
        id: '118',
        name: 'Djibouti', countryCode2: 'DJ',
        countryCode3: 'DJI',
        countryPrefix: '+253',
    },
    {
        id: '119',
        name: 'Dominica', countryCode2: 'DM',
        countryCode3: 'DMA',
        countryPrefix: '+1-767',
    },
    {
        id: '3',
        name: 'Denmark', countryCode2: 'DK',
        countryCode3: 'DNK',
        countryPrefix: '+45'
    },
    {
        id: '45',
        name: 'Dominican Republic', countryCode2: 'DO',
        countryCode3: 'DOM',
        countryPrefix: '+1-809 and 1-829',
    },
    {
        id: '19',
        name: 'Algeria', countryCode2: 'DZ',
        countryCode3: 'DZA',
        countryPrefix: '+213',
    },
    {
        id: '46',
        name: 'Ecuador', countryCode2: 'EC',
        countryCode3: 'ECU',
        countryPrefix: '+593',
    },
    {
        id: '18',
        name: 'Egypt', countryCode2: 'EG',
        countryCode3: 'EGY',
        countryPrefix: '+20',
    },
    {
        id: '121',
        name: 'Eritrea', countryCode2: 'ER',
        countryCode3: 'ERI',
        countryPrefix: '+291',
    },
    {
        id: '15',
        name: 'Spain', countryCode2: 'ES',
        countryCode3: 'ESP',
        countryPrefix: '+34'
    },
    {
        id: '120',
        name: 'Estonia', countryCode2: 'EE',
        countryCode3: 'EST',
        countryPrefix: '+372'
    },
    {
        id: '122',
        name: 'Ethiopia', countryCode2: 'ET',
        countryCode3: 'ETH',
        countryPrefix: '+251',
    },
    {
        id: '32',
        name: 'Finland', countryCode2: 'FI',
        countryCode3: 'FIN',
        countryPrefix: '+358'
    },
    {
        id: '123',
        name: 'Fiji', countryCode2: 'FJ',
        countryCode3: 'FJI',
        countryPrefix: '+679',
    },
    {
        id: '5',
        name: 'France', countryCode2: 'FR',
        countryCode3: 'FRA',
        countryPrefix: '+33'
    },
    {
        id: '124',
        name: 'Federated States of Micronesia', countryCode2: 'FM',
        countryCode3: 'FSM',
        countryPrefix: '+691',
    },
    {
        id: '125',
        name: 'Gabon', countryCode2: 'GA',
        countryCode3: 'GAB',
        countryPrefix: '+241',
    },
    {
        id: '4',
        name: 'Great Britain', countryCode2: 'GB',
        countryCode3: 'GBR',
        countryPrefix: '+44',
    },
    {
        id: '87',
        name: 'Georgia', countryCode2: 'GE',
        countryCode3: 'GEO',
        countryPrefix: '+995',
    },
    {
        id: '127',
        name: 'Ghana', countryCode2: 'GH',
        countryCode3: 'GHA',
        countryPrefix: '+233',
    },
    {
        id: '128',
        name: 'Gibraltar', countryCode2: 'GI',
        countryCode3: 'GIB',
        countryPrefix: '+350',
    },
    {
        id: '131',
        name: 'Guinea', countryCode2: 'GN',
        countryCode3: 'GIN',
        countryPrefix: '+224',
    },
    {
        id: '132',
        name: 'Guadeloupe', countryCode2: 'GP',
        countryCode3: 'GLP',
        countryPrefix: '+590',
    },
    {
        id: '130',
        name: 'Gambia', countryCode2: 'GM',
        countryCode3: 'GMB',
        countryPrefix: '+220',
    },
    {
        id: '135',
        name: 'Guinea-Bissau', countryCode2: 'GW',
        countryCode3: 'GNB',
        countryPrefix: '+245',
    },
    {
        id: '133',
        name: 'Equatorial Guinea', countryCode2: 'GQ',
        countryCode3: 'GNQ',
        countryPrefix: '+240',
    },
    {
        id: '23',
        name: 'Greece', countryCode2: 'GR',
        countryCode3: 'GRC',
        countryPrefix: '+30'
    },
    {
        id: '126',
        name: 'Grenada', countryCode2: 'GD',
        countryCode3: 'GRD',
        countryPrefix: '+1-473',
    },
    {
        id: '129',
        name: 'Greenland', countryCode2: 'GL',
        countryCode3: 'GRL',
        countryPrefix: '+299',
    },
    {
        id: '47',
        name: 'Guatemala', countryCode2: 'GT',
        countryCode3: 'GTM',
        countryPrefix: '+502',
    },
    {
        id: '134',
        name: 'Guam', countryCode2: 'GU',
        countryCode3: 'GUM',
        countryPrefix: '+1-671',
    },
    {
        id: '136',
        name: 'Guyana', countryCode2: 'GY',
        countryCode3: 'GUY',
        countryPrefix: '+592',
    },
    {
        id: '24',
        name: 'Hong Kong', countryCode2: 'HK',
        countryCode3: 'HKG',
        countryPrefix: '+852',
    },
    {
        id: '48',
        name: 'Honduras', countryCode2: 'HN',
        countryCode3: 'HND',
        countryPrefix: '+504',
    },
    {
        id: '89',
        name: 'Croatia', countryCode2: 'HR',
        countryCode3: 'HRV',
        countryPrefix: '+385'
    },
    {
        id: '137',
        name: 'Haiti', countryCode2: 'HT',
        countryCode3: 'HTI',
        countryPrefix: '+509',
    },
    {
        id: '49',
        name: 'Hungary', countryCode2: 'HU',
        countryCode3: 'HUN',
        countryPrefix: '+36'
    },
    {
        id: '25',
        name: 'Indonesia', countryCode2: "id",
        countryCode3: 'IDN',
        countryPrefix: '+62',
    },
    {
        id: '52',
        name: 'India', countryCode2: 'IN',
        countryCode3: 'IND',
        countryPrefix: '+91',
    },
    {
        id: '50',
        name: 'Ireland', countryCode2: 'IE',
        countryCode3: 'IRL',
        countryPrefix: '+353'
    },
    {
        id: '26',
        name: 'Islamic Republic of Iran', countryCode2: 'IR',
        countryCode3: 'IRN',
        countryPrefix: '+98',
    },
    {
        id: '138',
        name: 'Iraq', countryCode2: 'IQ',
        countryCode3: 'IRQ',
        countryPrefix: '+964',
    },
    {
        id: '53',
        name: 'Iceland', countryCode2: 'IS',
        countryCode3: 'ISL',
        countryPrefix: '+354',
    },
    {
        id: '51',
        name: 'Israel', countryCode2: 'IL',
        countryCode3: 'ISR',
        countryPrefix: '+972',
    },
    {
        id: '6',
        name: 'Italy', countryCode2: 'IT',
        countryCode3: 'ITA',
        countryPrefix: '+39'
    },
    {
        id: '54',
        name: 'Jamaica', countryCode2: 'JM',
        countryCode3: 'JAM',
        countryPrefix: '+1-876',
    },
    {
        id: '55',
        name: 'Jordan', countryCode2: 'JO',
        countryCode3: 'JOR',
        countryPrefix: '+962',
    },
    {
        id: '56',
        name: 'Japan', countryCode2: 'JP',
        countryCode3: 'JPN',
        countryPrefix: '+81',
    },
    {
        id: '145',
        name: 'Kazakhstan', countryCode2: 'KZ',
        countryCode3: 'KAZ',
        countryPrefix: '+7',
    },
    {
        id: '57',
        name: 'Kenya', countryCode2: 'KE',
        countryCode3: 'KEN',
        countryPrefix: '+254',
    },
    {
        id: '139',
        name: 'Kyrgyzstan', countryCode2: 'KG',
        countryCode3: 'KGZ',
        countryPrefix: '+996',
    },
    {
        id: '140',
        name: 'Cambodia', countryCode2: 'KH',
        countryCode3: 'KHM',
        countryPrefix: '+855',
    },
    {
        id: '141',
        name: 'Kiribati', countryCode2: 'KI',
        countryCode3: 'KIR',
        countryPrefix: '+686',
    },
    {
        id: '143',
        name: 'Saint Kitts and Nevis', countryCode2: 'KN',
        countryCode3: 'KNA',
        countryPrefix: '+1-869',
    },
    {
        id: '58',
        name: 'Republic of Korea', countryCode2: 'KR',
        countryCode3: 'KOR',
        countryPrefix: '+82',
    },
    {
        id: '59',
        name: 'Kuwait', countryCode2: 'KW',
        countryCode3: 'KWT',
        countryPrefix: '+965',
    },
    {
        id: '146',
        name: 'Lao People\'s Democratic Republic', countryCode2: 'LA',
        countryCode3: 'LAO',
        countryPrefix: '+856',
    },
    {
        id: '90',
        name: 'Lebanon', countryCode2: 'LB',
        countryCode3: 'LBN',
        countryPrefix: '+961',
    },
    {
        id: '91',
        name: 'Liberia', countryCode2: 'LR',
        countryCode3: 'LBR',
        countryPrefix: '+231',
    },
    {
        id: '27',
        name: 'Libyan Arab Jamahiriya', countryCode2: 'LY',
        countryCode3: 'LBY',
        countryPrefix: '+218',
    },
    {
        id: '147',
        name: 'Saint Lucia', countryCode2: 'LC',
        countryCode3: 'LCA',
        countryPrefix: '+1-758',
    },
    {
        id: '148',
        name: 'Liechtenstein', countryCode2: 'LI',
        countryCode3: 'LIE',
        countryPrefix: '+423',
    },
    {
        id: '92',
        name: 'Sri Lanka', countryCode2: 'LK',
        countryCode3: 'LKA',
        countryPrefix: '+94',
    },
    {
        id: '149',
        name: 'Lesotho', countryCode2: 'LS',
        countryCode3: 'LSO',
        countryPrefix: '+266',
    },
    {
        id: '150',
        name: 'Lithuania', countryCode2: 'LT',
        countryCode3: 'LTU',
        countryPrefix: '+370'
    },
    {
        id: '8',
        name: 'Luxembourg', countryCode2: 'LU',
        countryCode3: 'LUX',
        countryPrefix: '+352'
    },
    {
        id: '60',
        name: 'Latvia', countryCode2: 'LV',
        countryCode3: 'LVA',
        countryPrefix: '+371'
    },
    {
        id: '158',
        name: 'Macao', countryCode2: 'MO',
        countryCode3: 'MAC',
        countryPrefix: '+853',
    },
    {
        id: '61',
        name: 'Morocco', countryCode2: 'MA',
        countryCode3: 'MAR',
        countryPrefix: '+212',
    },
    {
        id: '151',
        name: 'Monaco', countryCode2: 'MC',
        countryCode3: 'MCO',
        countryPrefix: '+377',
    },
    {
        id: '152',
        name: 'Republic of Moldova', countryCode2: 'MD',
        countryCode3: 'MDA',
        countryPrefix: '+373',
    },
    {
        id: '153',
        name: 'Madagascar', countryCode2: 'MG',
        countryCode3: 'MDG',
        countryPrefix: '+261',
    },
    {
        id: '162',
        name: 'Maldives', countryCode2: 'MV',
        countryCode3: 'MDV',
        countryPrefix: '+960',
    },
    {
        id: '64',
        name: 'Mexico', countryCode2: 'MX',
        countryCode3: 'MEX',
        countryPrefix: '+52',
    },
    {
        id: '154',
        name: 'Marshall Islands', countryCode2: 'MH',
        countryCode3: 'MHL',
        countryPrefix: '+692',
    },
    {
        id: '86',
        name: 'The Former Yugoslav Republic of Macedonia', countryCode2: 'MK',
        countryCode3: 'MKD',
        countryPrefix: '+389',
    },
    {
        id: '156',
        name: 'Mali', countryCode2: 'ML',
        countryCode3: 'MLI',
        countryPrefix: '+223',
    },
    {
        id: '62',
        name: 'Malta', countryCode2: 'MT',
        countryCode3: 'MLT',
        countryPrefix: '+356'
    },
    {
        id: '155',
        name: 'Myanmar', countryCode2: 'MM',
        countryCode3: 'MMR',
        countryPrefix: '+95',
    },
    {
        id: '204',
        name: 'Montenegro', countryCode2: 'ME',
        countryCode3: 'MNE',
        countryPrefix: '+382',
    },
    {
        id: '157',
        name: 'Mongolia', countryCode2: 'MN',
        countryCode3: 'MNG',
        countryPrefix: '+976',
    },
    {
        id: '164',
        name: 'Mozambique', countryCode2: 'MZ',
        countryCode3: 'MOZ',
        countryPrefix: '+258',
    },
    {
        id: '160',
        name: 'Mauritania', countryCode2: 'MR',
        countryCode3: 'MRT',
        countryPrefix: '+222',
    },
    {
        id: '161',
        name: 'Montserrat', countryCode2: 'MS',
        countryCode3: 'MSR',
        countryPrefix: '+1-664',
    },
    {
        id: '159',
        name: 'Martinique', countryCode2: 'MQ',
        countryCode3: 'MTQ',
        countryPrefix: '+596',
    },
    {
        id: '63',
        name: 'Mauritius', countryCode2: 'MU',
        countryCode3: 'MUS',
        countryPrefix: '+230',
    },
    {
        id: '163',
        name: 'Malawi', countryCode2: 'MW',
        countryCode3: 'MWI',
        countryPrefix: '+265',
    },
    {
        id: '28',
        name: 'Malaysia', countryCode2: 'MY',
        countryCode3: 'MYS',
        countryPrefix: '+60',
    },
    {
        id: '200',
        name: 'Mayotte', countryCode2: 'YT',
        countryCode3: 'MYT',
        countryPrefix: '+262',
    },
    {
        id: '165',
        name: 'Namibia', countryCode2: 'NA',
        countryCode3: 'NAM',
        countryPrefix: '+264',
    },
    {
        id: '166',
        name: 'Niger', countryCode2: 'NE',
        countryCode3: 'NER',
        countryPrefix: '+227',
    },
    {
        id: '167',
        name: 'Nigeria', countryCode2: 'NG',
        countryCode3: 'NGA',
        countryPrefix: '+234',
    },
    {
        id: '168',
        name: 'Nicaragua', countryCode2: 'NI',
        countryCode3: 'NIC',
        countryPrefix: '+505',
    },
    {
        id: '9',
        name: 'Netherlands', countryCode2: 'NL',
        countryCode3: 'NLD',
        countryPrefix: '+31'
    },
    {
        id: '65',
        name: 'Norway', countryCode2: 'NO',
        countryCode3: 'NOR',
        countryPrefix: '+47',
    },
    {
        id: '66',
        name: 'Nepal', countryCode2: 'NP',
        countryCode3: 'NPL',
        countryPrefix: '+977',
    },
    {
        id: '170',
        name: 'Nauru', countryCode2: 'NR',
        countryCode3: 'NRU',
        countryPrefix: '+674',
    },
    {
        id: '67',
        name: 'New Zealand', countryCode2: 'NZ',
        countryCode3: 'NZL',
        countryPrefix: '+64',
    },
    {
        id: '169',
        name: 'Oman', countryCode2: 'OM',
        countryCode3: 'OMN',
        countryPrefix: '+968',
    },
    {
        id: '71',
        name: 'Pakistan', countryCode2: 'PK',
        countryCode3: 'PAK',
        countryPrefix: '+92',
    },
    {
        id: '68',
        name: 'Panama', countryCode2: 'PA',
        countryCode3: 'PAN',
        countryPrefix: '+507',
    },
    {
        id: '69',
        name: 'Peru', countryCode2: 'PE',
        countryCode3: 'PER',
        countryPrefix: '+51',
    },
    {
        id: '70',
        name: 'Philippines', countryCode2: 'PH',
        countryCode3: 'PHL',
        countryPrefix: '+63',
    },
    {
        id: '171',
        name: 'Palau', countryCode2: 'PW',
        countryCode3: 'PLW',
        countryPrefix: '+680',
    },
    {
        id: '35',
        name: 'Papua New Guinea', countryCode2: 'PG',
        countryCode3: 'PNG',
        countryPrefix: '+675',
    },
    {
        id: '11',
        name: 'Poland', countryCode2: 'PL',
        countryCode3: 'POL',
        countryPrefix: '+48'
    },
    {
        id: '72',
        name: 'Puerto Rico', countryCode2: 'PR',
        countryCode3: 'PRI',
        countryPrefix: '+1-787 and 1-939',
    },
    {
        id: '144',
        name: 'Democratic People\'s Republic of Korea', countryCode2: 'KP',
        countryCode3: 'PRK',
        countryPrefix: '+850',
    },
    {
        id: '12',
        name: 'Portugal', countryCode2: 'PT',
        countryCode3: 'PRT',
        countryPrefix: '+351'
    },
    {
        id: '73',
        name: 'Paraguay', countryCode2: 'PY',
        countryCode3: 'PRY',
        countryPrefix: '+595',
    },
    {
        id: '172',
        name: 'Qatar', countryCode2: 'QA',
        countryCode3: 'QAT',
        countryPrefix: '+974',
    },
    {
        id: '74',
        name: 'Romania', countryCode2: 'RO',
        countryCode3: 'ROU',
        countryPrefix: '+40'
    },
    {
        id: '203',
        name: 'Russian Federation',
        countryCode2: 'RU',
        countryCode3: 'RUS',
        countryPrefix: '+7',
    },
    {
        id: '173',
        name: 'Rwanda', countryCode2: 'RW',
        countryCode3: 'RWA',
        countryPrefix: '+250',
    },
    {
        id: '29',
        name: 'Saudi Arabia', countryCode2: 'SA',
        countryCode3: 'SAU',
        countryPrefix: '+966',
    },
    {
        id: '175',
        name: 'Sudan', countryCode2: 'SD',
        countryCode3: 'SDN',
        countryPrefix: '+249',
    },
    {
        id: '180',
        name: 'Senegal', countryCode2: 'SN',
        countryCode3: 'SEN',
        countryPrefix: '+221',
    },
    {
        id: '75',
        name: 'Singapore', countryCode2: 'SG',
        countryCode3: 'SGP',
        countryPrefix: '+65',
    },
    {
        id: '176',
        name: 'Svalbard and Jan Mayen', countryCode2: 'SJ',
        countryCode3: 'SJM',
        countryPrefix: '+47',
    },
    {
        id: '178',
        name: 'Sierra Leone', countryCode2: 'SL',
        countryCode3: 'SLE',
        countryPrefix: '+232',
    },
    {
        id: '76',
        name: 'El Salvador', countryCode2: 'SV',
        countryCode3: 'SLV',
        countryPrefix: '+503',
    },
    {
        id: '179',
        name: 'San Marino', countryCode2: 'SM',
        countryCode3: 'SMR',
        countryPrefix: '+378',
    },
    {
        id: '181',
        name: 'Somalia', countryCode2: 'SO',
        countryCode3: 'SOM',
        countryPrefix: '+252',
    },
    {
        id: '205',
        name: 'Serbia', countryCode2: 'RS',
        countryCode3: 'SRB',
        countryPrefix: '+381',
    },
    {
        id: '183',
        name: 'Sao Tome and Principe', countryCode2: 'ST',
        countryCode3: 'STP',
        countryPrefix: '+239',
    },
    {
        id: '182',
        name: 'Suriname', countryCode2: 'SR',
        countryCode3: 'SUR',
        countryPrefix: '+597',
    },
    {
        id: '177',
        name: 'Slovakia', countryCode2: 'SK',
        countryCode3: 'SVK',
        countryPrefix: '+421'
    },
    {
        id: '14',
        name: 'Slovenia', countryCode2: 'SI',
        countryCode3: 'SVN',
        countryPrefix: '+386'
    },
    {
        id: '30',
        name: 'Sweden', countryCode2: 'SE',
        countryCode3: 'SWE',
        countryPrefix: '+46'
    },
    {
        id: '184',
        name: 'Swaziland', countryCode2: 'SZ',
        countryCode3: 'SWZ',
        countryPrefix: '+268',
    },
    {
        id: '174',
        name: 'Seychelles', countryCode2: 'SC',
        countryCode3: 'SYC',
        countryPrefix: '+248',
    },
    {
        id: '77',
        name: 'Syrian Arab Republic', countryCode2: 'SY',
        countryCode3: 'SYR',
        countryPrefix: '+963',
    },
    {
        id: '185',
        name: 'Chad', countryCode2: 'TD',
        countryCode3: 'TCD',
        countryPrefix: '+235',
    },
    {
        id: '186',
        name: 'Togo', countryCode2: 'TG',
        countryCode3: 'TGO',
        countryPrefix: '+228',
    },
    {
        id: '78',
        name: 'Thailand', countryCode2: 'TH',
        countryCode3: 'THA',
        countryPrefix: '+66',
    },
    {
        id: '187',
        name: 'Tajikistan', countryCode2: 'TJ',
        countryCode3: 'TJK',
        countryPrefix: '+992',
    },
    {
        id: '188',
        name: 'Turkmenistan', countryCode2: 'TM',
        countryCode3: 'TKM',
        countryPrefix: '+993',
    },
    {
        id: '189',
        name: 'Tonga',
        countryCode2: 'TO',
        countryCode3: 'TON',
        countryPrefix: '+676',
    },
    {
        id: '80',
        name: 'Trinidad and Tobago', countryCode2: 'TT',
        countryCode3: 'TTO',
        countryPrefix: '+1-868',
    },
    {
        id: '93',
        name: 'Tunisia', countryCode2: 'TN',
        countryCode3: 'TUN',
        countryPrefix: '+216',
    },
    {
        id: '79',
        name: 'Turkey', countryCode2: 'TR',
        countryCode3: 'TUR',
        countryPrefix: '+90',
    },
    {
        id: '190',
        name: 'Tuvalu', countryCode2: 'TV',
        countryCode3: 'TUV',
        countryPrefix: '+688',
    },
    {
        id: '191',
        name: 'United Republic of Tanzania', countryCode2: 'TZ',
        countryCode3: 'TZA',
        countryPrefix: '+255',
    },
    {
        id: '192',
        name: 'Uganda', countryCode2: 'UG',
        countryCode3: 'UGA',
        countryPrefix: '+256',
    },
    {
        id: '81',
        name: 'Ukraine', countryCode2: 'UA',
        countryCode3: 'UKR',
        countryPrefix: '+380',
    },
    {
        id: '82',
        name: 'Uruguay', countryCode2: 'UY',
        countryCode3: 'URY',
        countryPrefix: '+598',
    },
    {
        id: '17',
        name: 'USA', countryCode2: 'US',
        countryCode3: 'USA',
        countryPrefix: '+1',
    },
    {
        id: '193',
        name: 'Uzbekistan', countryCode2: 'UZ',
        countryCode3: 'UZB',
        countryPrefix: '+998',
    },
    {
        id: '194',
        name: 'Holy See (Vatican City State)', countryCode2: 'VA',
        countryCode3: 'VAT',
        countryPrefix: '+379',
    },
    {
        id: '195',
        name: 'Saint Vincent and The Grenadines', countryCode2: 'VC',
        countryCode3: 'VCT',
        countryPrefix: '+1-784',
    },
    {
        id: '83',
        name: 'Venezuela', countryCode2: 'VE',
        countryCode3: 'VEN',
        countryPrefix: '+58',
    },
    {
        id: '84',
        name: 'Viet Nam', countryCode2: 'VN',
        countryCode3: 'VNM',
        countryPrefix: '+84',
    },
    {
        id: '196',
        name: 'Vanuatu', countryCode2: 'VU',
        countryCode3: 'VUT',
        countryPrefix: '+678',
    },
    {
        id: '197',
        name: 'Wallis and Futuna', countryCode2: 'WF',
        countryCode3: 'WLF',
        countryPrefix: '+681',
    },
    {
        id: '198',
        name: 'Samoa', countryCode2: 'WS',
        countryCode3: 'WSM',
        countryPrefix: '+685',
    },
    {
        id: '208',
        name: 'Kosovo', countryCode2: 'XK',
        countryCode3: 'XKX',
        countryPrefix: '+383',
    },
    {
        id: '199',
        name: 'Yemen', countryCode2: 'YE',
        countryCode3: 'YEM',
        countryPrefix: '+967',
    },
    {
        id: '85',
        name: 'South Africa', countryCode2: 'ZA',
        countryCode3: 'ZAF',
        countryPrefix: '+27',
    },
    {
        id: '201',
        name: 'Zambia', countryCode2: 'ZM',
        countryCode3: 'ZMB',
        countryPrefix: '+260',
    },
    {
        id: '202',
        name: 'Zimbabwe',
        countryCode2: 'ZW',
        countryCode3: 'ZWE',
        countryPrefix: '+263'
    }
];
